import { AbstractModel, JsonObject, JsonProperty, DateConverter } from 'projects/core/src/public-api';
import { ItemRef } from './item-ref';

@JsonObject('model.project.SaleItemDetail')
export class SaleItemDetail extends AbstractModel {

    @JsonProperty(Number, 'qty')
    qty?: number;

    @JsonProperty(Number, 'unitPrice')
    unitPrice?: number;

    @JsonProperty(ItemRef, 'itemAccountRef')
    itemAccountRef?: ItemRef;

    @JsonProperty(ItemRef, 'itemRef')
    itemRef?: ItemRef;

    @JsonProperty(ItemRef, 'classRef')
    classRef?: ItemRef;

}
